export default "__VITE_ASSET__8d8b8e33__"